import Product from '../../domains/Product/Product'

export interface ICustomProductFeedResponse {
  readonly data: ICustomProductFeed[]
  readonly next_url: string
}

export interface ICustomProductFeed {
  readonly website_product: Product
  readonly color_order: string[]
}

export enum PRODUCT_FEED_TYPE {
  CUSTOMER_TOP_PRODUCTS = 'CUSTOMER_TOP_PRODUCTS',
  CUSTOMER_TOP_SIMILAR_PRODUCTS = 'CUSTOMER_TOP_SIMILAR_PRODUCTS',
  FBT = 'FBT',
  CUSTOMER_PERSONALIZED_PRODUCTS = 'CUSTOMER_PERSONALIZED_PRODUCTS',
}
